import { CHART_FREQUENCY } from '@/entities/chart/model/constants';
import type { FeedbackPeakAnalysisOptions } from '@/features/Feedback/components/FeedbackListModal/peak-analysis';
import { FEEDBACK_COLUMNS } from '@/types/filterKeyConst';
import { RangeUnit } from '@/utils/getDatePreset';

const getChartFrequencyFromRangeUnit = (
  rangeUnit: RangeUnit,
): CHART_FREQUENCY | null => {
  switch (rangeUnit) {
    case RangeUnit.Hourly:
      return CHART_FREQUENCY.HOUR;
    case RangeUnit.Daily:
      return CHART_FREQUENCY.DAY;
    case RangeUnit.Weekly:
      return CHART_FREQUENCY.WEEK;
    case RangeUnit.Monthly:
      return CHART_FREQUENCY.MONTH;
    default:
      return null;
  }
};

export const buildInsightExplorerPeakAnalysisOptions = ({
  filter,
  viewType,
  chartName,
  autoStart,
}: {
  filter?: StructuredFilter;
  viewType: RangeUnit;
  chartName?: string;
  autoStart?: boolean;
}): FeedbackPeakAnalysisOptions | undefined => {
  const frequency = getChartFrequencyFromRangeUnit(viewType);
  if (frequency == null) return undefined;

  if (
    !filter ||
    typeof filter[FEEDBACK_COLUMNS.DATE_START] !== 'string' ||
    typeof filter[FEEDBACK_COLUMNS.DATE_END] !== 'string'
  ) {
    return undefined;
  }

  return {
    autoStart,
    chartName,
    filterSet: filter,
    frequency,
  };
};
